const React = require("react");
const { useSyncExternalStore } = require("use-sync-external-store/shim");

if (typeof React.useSyncExternalStore !== "function") {
    React.useSyncExternalStore = useSyncExternalStore;
}
